<div class="w-100 d-flex justify-content-center align-items-center" style="height: 100vh;">

    <p class="mb-0"> {{ message }} </p>

    <!-- http://localhost:58118/live?Key=OsNVldW3WY9S0PX5GPilLwqjlQBaa0mO57Cs6riId8JeEbkWMAvB4976EF2YstdngcEYLRRsJ3ueoTdR/8cjSfJRaUDlWdHse3kK2adUnWE= -->

</div>